import FormularioFacturacion from 'containers/DatosFacturacionQr/FormularioFacturacion';
import React, {useEffect} from 'react';
import useFormularioFacturacionConfig from './useFormularioFacturacionConfig';
import useQueryParams from 'hooks/useQueryParams';
import useValidationsSuscriptor from "hooks/useValidationsSuscriptor";
import { useSelector } from "react-redux";

const FormularioFacturacionGeneral = () => {
  const { Back, Next, breadCrumb, history, figurasHabilitadas } = useFormularioFacturacionConfig(); 
  const qParams = useQueryParams();
  const { ramo } = qParams;
  const { validarSuscriptor } = useValidationsSuscriptor();
  const { dataUsuario } = useSelector((state) => state.datosUsuarios);


  useEffect(() => {    
    validarSuscriptor(ramo)
  
  }, []);

  return (
    <React.Fragment>
      <div>
        <FormularioFacturacion
          BreadcrumbRender={breadCrumb}
          Next={Next}
          Back={Back}
          history={history}
          {...figurasHabilitadas}
        />
      </div>
    </React.Fragment>
  );
};

export default FormularioFacturacionGeneral;
